import React, { createContext, useContext, useState, ReactNode, useEffect, useCallback } from 'react';
import { PlanosService } from './Service';
import { useAuthContext } from '../../../contexts/AuthContext';
const service = new PlanosService();

interface Data {
    _id: string;
    status: number;
    name: string;
}

interface EstabsContextProps {
    data: Data[];
    loading: boolean;
    error: boolean;
    reloadData: () => Promise<void>;
}

const EstabsContext = createContext<EstabsContextProps | undefined>(undefined);

export const usePlanosContext = () => {
    const context = useContext(EstabsContext);
    if (!context) {
        throw new Error('usePlanosContext must be used within a UsersProvider');
    }
    return context;
};

export const PlanosProvider = ({ children }: { children: ReactNode }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [data, setData] = useState<Data[]>([]);
    const { user, loadingAuth } = useAuthContext();

    const reloadData = useCallback(async () => {
        try {
            setError(false);
            const result = await service.findAll().then((result) => result?.data || []);
            const hideInactive = Boolean(user?.worker && !user?.admin && !user?.root);
            const filtered = hideInactive
                ? result.filter((plano: any) => plano.status === 1)
                : result;
            setData(filtered);
        } catch (error) {
            console.error('Error fetching Estabelecimentos:', error);
            setError(true);
        } finally {
            setLoading(false);
        }
    }, [user?.admin, user?.root, user?.worker]);

    useEffect(() => {
        if (loadingAuth) return;
        reloadData();
    }, [loadingAuth, reloadData]);

    return <EstabsContext.Provider value={{ data, reloadData, loading, error }}>{children}</EstabsContext.Provider>;
};
